const DEVELOPER_PREFIX = '/developer';

export const ROUTE_DEVELOPER = DEVELOPER_PREFIX;

export const ROUTE_DEVELOPER_REGISTRATION = `${DEVELOPER_PREFIX}/registration`;

export const ROUTE_DEVELOPER_DASHBOARD_API_REFERENCES = `${DEVELOPER_PREFIX}/api-preferences`;
export const ROUTE_DEVELOPER_DASHBOARD_SANDBOXES = `${DEVELOPER_PREFIX}/sandboxes`;
export const ROUTE_DEVELOPER_DASHBOARD = `${DEVELOPER_PREFIX}/dashboard`;
export const ROUTE_DEVELOPER_ADD_NEW_APPLICATION = `${DEVELOPER_PREFIX}/add-application`;

export const DEFINITION_ROUTE_DEVELOPER_DASHBOARD_APPLICATION = `${ROUTE_DEVELOPER_DASHBOARD}/application/`;
export const ROUTE_DEVELOPER_DASHBOARD_APPLICATION = `${DEFINITION_ROUTE_DEVELOPER_DASHBOARD_APPLICATION}:id`;
export const ROUTE_DEVELOPER_DASHBOARD_MY_PROFILE = `${ROUTE_DEVELOPER_DASHBOARD}/profile`

export const ROUTE_DEVELOPER_REGISTRATION_CONFIRMATION = `${DEVELOPER_PREFIX}/registerconfirm`;
export const ROUTE_DEVELOPER_LOGIN = `/login`;
export const ROUTE_DEVELOPER_LANDING_REDIRECT = `${DEVELOPER_PREFIX}/sign-in/redirect`
export const ROUTE_404 = '/developer/notfound';

//Greenway Health Developers pages(redirects outside the scope of Developer platform)
export const DEV_README_PREFIX = "https://developers.greenwayhealth.com/developer-platform";

export const TERMS_OF_SERVICE = `${DEV_README_PREFIX}/page/terms-of-service`;
export const DEV_BEST_PRACTICES = `${DEV_README_PREFIX}/page/code-of-developer-best-practices`;
export const PRIVACY_POLICY = `${DEV_README_PREFIX}/page/privacy-policy`;
